'use client';

import Link from 'next/link';
import type { ReactElement } from 'react';

export default function Legal(): ReactElement {
  return (
    <div className="w-full flex items-center justify-center gap-2 sm:gap-3 text-center">
      <p className="font-light text-xs sm:text-base opacity-80 hover:opacity-100">We use cookies</p>
      <Link
        href="/legal/privacy-policy"
        className="font-light text-xs sm:text-base opacity-80 hover:opacity-100"
        target="_blank"
      >
        Privacy Policy
      </Link>
      <Link
        href="/legal/terms-of-use"
        className="font-light text-xs sm:text-base opacity-80 hover:opacity-100"
        target="_blank"
      >
        Terms of Use
      </Link>
    </div>
  );
}
